/**
 * User restriction / delete translation keys (CR 16)
 */
const k = (suffix) => `admin.user_restriction_${suffix}`;

export const userRestriction = {
  restrict_action: k("restrict_action"),
  lift_restriction_action: k("lift_restriction_action"),
  delete_action: k("delete_action"),
  deactivate_action: k("deactivate_action"),
  activate_action: k("activate_action"),
  view_action: k("view_action"),
  actions_menu: k("actions_menu"),
  status_restricted: k("status_restricted"),
  restrict_heading: k("restrict_heading"),
  restrict_message: k("restrict_message"),
  restrict_reason_label: k("restrict_reason_label"),
  restrict_reason_placeholder: k("restrict_reason_placeholder"),
  restrict_reason_required: k("restrict_reason_required"),
  restrict_end_label: k("restrict_end_label"),
  restrict_until_manual: k("restrict_until_manual"),
  restrict_end_required: k("restrict_end_required"),
  restrict_end_past: k("restrict_end_past"),
  restrict_submit: k("restrict_submit"),
  restrict_cancel: k("restrict_cancel"),
  lift_heading: k("lift_heading"),
  lift_message: k("lift_message"),
  delete_heading: k("delete_heading"),
  delete_message: k("delete_message"),
  delete_reason_placeholder: k("delete_reason_placeholder"),
  delete_submit: k("delete_submit"),
  delete_handoff_blocked: k("delete_handoff_blocked"),
  restriction_card_title: k("restriction_card_title"),
  restriction_reason: k("restriction_reason"),
  restriction_end_date: k("restriction_end_date"),
  restriction_end_manual: k("restriction_end_manual"),
  restriction_by: k("restriction_by"),
  restriction_at: k("restriction_at"),
  restrict_tooltip: k("restrict_tooltip"),
  lift_tooltip: k("lift_tooltip"),
  deleted_reason: k("deleted_reason"),
  yes: k("yes"),
  no: k("no"),
};

export default userRestriction;
